import * as React from 'react';
import { useRef } from 'react';
import { SearchInput } from './SearchHeaderBlocks/SearchInput';

interface SearchInputBlockProps {
  settings?: {
    placeholder_text?: string;
    search_results_event_name?: string;
    search_state_event_name?: string;
    search_clear_event_name?: string;
    enable_search_events?: boolean;
    search_events_to_trigger?: string;
    [key: string]: any;
  };
  className?: string;
}

export const SearchInputBlock: React.FC<SearchInputBlockProps> = ({ settings, className = '' }) => {
  const blockSettings = settings?.settings?.block_settings || settings || {};
  const searchInputRef = useRef<any>(null);

  return (
    <div className={`w-full ${className}`}>
        <SearchInput
          ref={searchInputRef}
          settings={settings}
          placeholder={blockSettings.placeholder_text || 'Search'}
          isLoading={false}
          maintainFocus={true}
          type="search-header"
          searchEventsToTrigger={blockSettings.search_events_to_trigger}
          enableSearchEvents={blockSettings.enable_search_events !== false}
        />
    </div>
  );
};